import { ScanOrderPayProps } from "@definitions/types"
import OrderImage from "@public/images/home/order.png"
import PayImage from "@public/images/home/pay.png"
import ScanImage from "@public/images/home/scan.png"
export const ScanOrderPayData: ScanOrderPayProps[] = [
  {
    title: "scan",
    image: ScanImage,
  },
  {
    title: "order",
    image: OrderImage,
  },
  {
    title: "pay",
    image: PayImage,
  },
]
